import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useUserIsClient } from "../../../hooks/useCurrentUser";
import {
  CLIENT_EXERCISE_HISTORY_ROUTE,
  COACH_CLIENT_EXERCISE_HISTORY_ROUTE,
} from "../../../routes/routes";
import {
  UserExerciseDto,
  ExerciseAssetDto,
} from "@growth-machine-llc/stridist-api-client";

export const useExerciseHistoryNavigation = (username?: string) => {
  const navigate = useNavigate();
  const isClient = useUserIsClient();

  const handleExerciseSelect = useCallback(
    (exercise: any) => {
      const historyPath = isClient
        ? CLIENT_EXERCISE_HISTORY_ROUTE
        : COACH_CLIENT_EXERCISE_HISTORY_ROUTE.replace(
            ":username",
            username || "",
          );

      const assetId =
        exercise.assetId || exercise.id || exercise.exercise?.assetId;
      const title = exercise.title || exercise.exercise?.title;

      const exerciseDto = new UserExerciseDto({
        id: 0,
        title: title,
        exercise: new ExerciseAssetDto({
          id: assetId,
          name: title,
        }),
      });

      navigate(historyPath, {
        state: { selectedExercise: exerciseDto },
      });
    },
    [isClient, navigate, username],
  );

  return { handleExerciseSelect };
};
